import React from "react";
import { Section, SectionTitle, Reveal } from "../components/Section";

const STORY = [
  {
    date: "Maret 2019",
    title: "Pertemuan Pertama",
    text: "Kami pertama bertemu di sebuah kafe kecil dekat kampus. Sebuah obrolan ringan tentang kopi favorit yang ternyata berubah menjadi awal segalanya.",
  },
  {
    date: "Desember 2020",
    title: "Menjadi Sepasang",
    text: "Setelah setahun lebih saling mengenal, kami sepakat menjalani hubungan ini dengan serius. Hujan Desember malam itu menjadi saksi.",
  },
  {
    date: "Agustus 2024",
    title: "Lamaran",
    text: "Dengan restu kedua keluarga, momen lamaran berjalan hangat dan sederhana — diisi tawa, doa, dan rasa syukur.",
  },
  {
    date: "Agustus 2026",
    title: "Hari Bahagia",
    text: "Dan akhirnya, hari yang kami nantikan tiba. Kami mengundang Anda untuk menjadi bagian dari babak baru cerita kami.",
  },
];

export default function LoveStory() {
  return (
    <Section testId="love-story-section" className="bg-cream/30">
      <SectionTitle overline="Our Journey" title="Love" italic="Story" />

      <div className="relative">
        {/* center vertical line */}
        <div className="hidden md:block absolute left-1/2 -translate-x-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-gold/50 to-transparent" />

        <div className="space-y-12 md:space-y-16">
          {STORY.map((s, i) => {
            const left = i % 2 === 0;
            return (
              <Reveal key={i} delay={i * 0.1}>
                <div className={`grid md:grid-cols-2 gap-6 md:gap-12 items-center ${left ? "" : "md:[direction:rtl]"}`}>
                  <div className={`md:text-right ${left ? "" : "md:text-left"}`} style={{ direction: "ltr" }}>
                    <p className="text-xs tracking-[0.3em] uppercase text-gold mb-2">{s.date}</p>
                    <h3 className="font-serif text-3xl text-charcoal mb-3">{s.title}</h3>
                    <p className="text-charcoal/70 leading-relaxed text-sm md:text-base">{s.text}</p>
                  </div>
                  <div className="hidden md:flex items-center justify-center relative" style={{ direction: "ltr" }}>
                    <div className="w-3 h-3 rounded-full bg-gold border-2 border-ivory shadow-md" />
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </Section>
  );
}
